import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,[_c(VCardTitle,[_c('h1',[_vm._v("Stats de "+_vm._s(_vm.membre.prenom)+" "+_vm._s(_vm.membre.name))])])],1),_c('p',{directives:[{name:"permission",rawName:"v-permission",value:('editer membres'),expression:"'editer membres'"}]},[_c('router-link',{attrs:{"to":{ name: 'membre-edit' }}},[_vm._v("Editer membre")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }